import { SVGProps } from 'react';

const SpellCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m6 16 6-12 6 12M8 12h8m0 8 2 2 4-4"
    />
  </svg>
);
export default SpellCheck;
